'use es6';

import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import emptyFunction from 'react-utils/emptyFunction';
import { bindAll } from 'underscore';
import FormattedMessage from 'I18n/components/FormattedMessage';
import text from 'I18n/utils/unescapedText';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIButton from 'UIComponents/button/UIButton';
import H2 from 'UIComponents/elements/headings/H2';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = key => `simpleMenusLib.components.modals.deleteNodeModal.${key}`;
const HOC = Component => {
  class WithDeleteMenuNodeModal extends PureComponent {
    constructor(props) {
      super(props);
      bindAll(this, ['deleteMenu', 'onCancel', 'onDeleteClick']);
      this.state = {
        open: false
      };
    }
    onDeleteClick() {
      if (this.props.hasChildren) {
        this.setState({
          open: true
        });
      } else {
        this.props.deleteNode();
      }
    }
    deleteMenu() {
      this.props.deleteNode();
      this.setState({
        open: false
      });
    }
    onCancel() {
      this.setState({
        open: false
      });
    }
    renderModal() {
      if (!this.state.open) return null;
      const linkLabel = this.props.linkLabel || text(i18nKey('placeholder'));
      return /*#__PURE__*/_jsxs(UIModal, {
        size: "auto",
        use: "danger",
        width: 600,
        children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
          children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
            onClick: this.onCancel
          }), /*#__PURE__*/_jsx(H2, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey('header'),
              options: {
                linkLabel
              }
            })
          })]
        }), /*#__PURE__*/_jsx(UIDialogBody, {
          children: /*#__PURE__*/_jsx("p", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey('body'),
              options: {
                linkLabel
              }
            })
          })
        }), /*#__PURE__*/_jsx(UIDialogFooter, {
          children: /*#__PURE__*/_jsx(UIButton, {
            use: "danger",
            onClick: this.deleteMenu,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey('button')
            })
          })
        })]
      });
    }
    render() {
      return /*#__PURE__*/_jsx(Component, Object.assign({}, this.props, {
        deleteMenuNodeModal: this.renderModal(),
        deleteNode: this.onDeleteClick
      }));
    }
  }
  WithDeleteMenuNodeModal.propTypes = {
    linkLabel: PropTypes.string.isRequired,
    hasChildren: PropTypes.bool.isRequired,
    deleteNode: PropTypes.func.isRequired
  };
  WithDeleteMenuNodeModal.defaultProps = {
    linkLabel: '',
    hasChildren: false,
    deleteNode: emptyFunction
  };
  return WithDeleteMenuNodeModal;
};
export default function withDeleteMenuModal() {
  return HOC;
}